export default function GlossaryBass() {
  return(
    <div className="">
      <h2 className="font-bold">Glosario:</h2>
      <ul className="ml-6">
        <li className="list-disc">x Dead note</li>
        <li className="list-disc">h Hammer-on</li>
        <li className="list-disc">p Pull-off</li>
        <li className="list-disc">/ Slide up</li>
      </ul>
    </div>
  )
}